import { IMemberDepricated } from "@mctypes/global.types";
import React, { useMemo } from "react";
import { useAppSelector } from "../../../../hooks";
import { McSelect } from "../../../../components/McSelect/McSelect";

import { usePutProjectMemberMutation } from "../../../../../openapi";
import { MEMBER_GROUPS } from "../../../globalConstants";

const ProjectGroupSelector: React.FC<{ group: string | null | undefined; memberId: string }> = ({
  group,
  memberId,
}) => {
  const project = useAppSelector((state) => state.adminReducer.project);

  const [updateMemberAttribute] = usePutProjectMemberMutation();

  const member = useMemo<IMemberDepricated | undefined>(
    () => project.members.find((mbr) => mbr._id === memberId),
    [project.members, memberId],
  );

  const memberIsMulticonsult = useMemo<boolean | null>(() => {
    if (member == null) {
      return null;
    }

    const email =
      typeof member.user === "string" ? null : (member.user as { email?: string } | null | undefined)?.email ?? null;
    return Boolean(email && email.toLowerCase().endsWith("@multiconsult.no"));
  }, [member]);

  const getItemsInMemberGroup = () => {
    if (member == null) {
      return MEMBER_GROUPS;
    }

    if (memberIsMulticonsult && member.group === "INTERNAL") {
      return MEMBER_GROUPS.filter((group) => {
        return group.value === "ADMIN" || group.value === "INTERNAL";
      });
    }

    if (memberIsMulticonsult && member.group === "ADMIN") {
      return MEMBER_GROUPS.filter((group) => {
        return group.value === "ADMIN" || group.value === "INTERNAL";
      });
    }

    if (memberIsMulticonsult === false && member.group !== "INTERNAL") {
      return MEMBER_GROUPS.filter((group) => {
        return group.value !== "INTERNAL";
      });
    }
    return MEMBER_GROUPS;
  };

  const options = getItemsInMemberGroup().map((memberGroup) => ({
    value: memberGroup.value,
    label: memberGroup.label,
  }));

  if (member == null || memberIsMulticonsult == null) {
    return null;
  }

  return (
    <McSelect
      w="100%"
      variant="unstyled"
      styles={{
        input: {
          background: "transparent",
          border: "none",
          boxShadow: "none",
          paddingInline: 0,
        },
      }}
      data={options}
      value={member.group ?? group ?? null}
      placeholder="Ikke satt"
      searchable={false}
      onChange={(value) => {
        if (value == null || value === member.group) {
          return;
        }

        updateMemberAttribute({
          body: {
            projectId: project._id,
            attribute: "group",
            value,
            memberId,
          },
        });
      }}
    />
  );
};

export default ProjectGroupSelector;
